{
  "common": {
    "save": "सुरक्षित गर्नुहोस्",
    "cancel": "रद्द गर्नुहोस्",
    "delete": "मेटाउनुहोस्",
    "edit": "सम्पादन गर्नुहोस्",
    "close": "बन्द गर्नुहोस्",
    "submit": "पेश गर्नुहोस्",
    "search": "खोज्नुहोस्",
    "loading": "लोड हुँदैछ...",
    "yes": "हो",
    "no": "होइन",
    "back": "पछाडि",
    "next": "अर्को",
    "previous": "अघिल्लो",
    "confirm": "पुष्टि गर्नुहोस्",
    "done": "सम्पन्न",
    "remove": "हटाउनुहोस्",
    "add": "थप्नुहोस्",
    "view": "हेर्नुहोस्",
    "create": "सिर्जना गर्नुहोस्",
    "update": "अद्यावधिक गर्नुहोस्",
    "ok": "ठीक छ",
    "none": "कुनै पनि छैन",
    "na": "लागू हुँदैन",
    "prepare": "तयार गर्नुहोस्",
    "approve": "स्वीकृत गर्नुहोस्",
    "uploadFiles": "फाइलहरू अपलोड गर्नुहोस्",
    "learnMore": "थप जान्नुहोस्",
    "user": "प्रयोगकर्ता",
    "users": "प्रयोगकर्ताहरू"
  },
  "nav": {
    "users": "प्रयोगकर्ताहरू",
    "groups": "समूहहरू",
    "developerApiTokens": "विकासकर्ता API टोकनहरू",
    "permissions": "अनुमतिहरू",
    "betaFeatures": "बीटा सुविधाहरू",
    "security": "सुरक्षा",
    "adminSettings": "प्रशासक सेटिङहरू"
  },
  "pages": {
    "unauthorized": {
      "title": "अनधिकृत",
      "heading": "हामी क्षमाप्रार्थी छौं!",
      "message": "तपाईंसँग यो पृष्ठमा पहुँच छैन जस्तो देखिन्छ।",
      "contactSupport": "यदि तपाईंलाई यो त्रुटि हो जस्तो लाग्छ भने, कृपया ग्राहक सफलता टोलीलाई सम्पर्क गर्नुहोस्।"
    },
    "errorBoundary": {
      "message": "केही गडबड भयो!"
    },
    "passwords": {
      "title": "पासवर्ड पृष्ठ",
      "description": "यो विकल्प सक्रिय गरिएपछि, तपाईंको संस्थाका सबैले आवधिक रूपमा आफ्नो पासवर्ड परिवर्तन गर्नुपर्नेछ।"
    },
    "singleSignOn": {
      "title": "सिङ्गल साइन अन पृष्ठ"
    },
    "logo": {
      "title": "लोगो अपलोड गर्नुहोस्",
      "description": "आफ्नो संस्थाको लोगो यहाँ अपलोड गर्नुहोस्, यो निर्यात गरिएका कागजातहरूमा देखाइनेछ।"
    }
  },
  "users": {
    "searchPlaceholder": "प्रयोगकर्ताहरू खोज्नुहोस्...",
    "filterByGroup": "समूहअनुसार फिल्टर गर्नुहोस्",
    "inviteUser": "प्रयोगकर्तालाई निमन्त्रणा पठाउनुहोस्",
    "setRole": "भूमिका तोक्नुहोस्",
    "addToGroup": "समूहमा थप्नुहोस्",
    "addToGroupCount": "{{count}} {{pluralized}} समूहमा थप्नुहोस्",
    "removeFromGroup": "समूहबाट हटाउनुहोस्",
    "removeFromGroupCount": "{{count}} {{pluralized}} समूहबाट हटाउनुहोस्",
    "manageGroups": "समूहहरू व्यवस्थापन गर्नुहोस्",
    "manageGroupsCount": "{{count}} {{pluralized}} का लागि समूहहरू व्यवस्थापन गर्नुहोस्",
    "editUser": "प्रयोगकर्ता सम्पादन गर्नुहोस्",
    "removeUser": "प्रयोगकर्ता हटाउनुहोस्",
    "cancelInvitation": "निमन्त्रणा रद्द गर्नुहोस्",
    "resendInvitation": "निमन्त्रणा पुनः पठाउनुहोस्",
    "usageMessage": "तपाईं आफ्नो हालको योजनामा उपलब्ध {{activeUsersLimit}} मध्ये {{activeUsersCount}} सक्रिय प्रयोगकर्ता र {{totalUsersLimit}} मध्ये {{totalUsersCount}} कुल प्रयोगकर्ता प्रयोग गर्दै हुनुहुन्छ। थप चाहिन्छ?",
    "upgradeSubscription": "आफ्नो सदस्यता अपग्रेड गर्नुहोस्",
    "addMoreSeats": "थप सिटहरू थप्नुहोस्",
    "table": {
      "fullName": "पूरा नाम",
      "email": "इमेल",
      "role": "भूमिका",
      "jobTitle": "पद",
      "department": "विभाग",
      "location": "स्थान",
      "groups": "समूहहरू",
      "access": "पहुँच"
    },
    "inviteStatus": {
      "pending": "विचाराधीन",
      "declined": "अस्वीकृत",
      "accepted": "स्वीकार गरिएको"
    },
    "editUsersUsage": "सम्पादन प्रयोगकर्ताहरू (सामान्य + गुणस्तर): {{activeUsersLimit}} मध्ये {{activeUsersCount}}",
    "basicUsersUsage": "आधारभूत प्रयोगकर्ताहरू: {{basicUsersLimit}} मध्ये {{basicUsersCount}}",
    "basicUsersUsageUnlimited": "आधारभूत प्रयोगकर्ताहरू: {{basicUsersCount}} (असीमित)"
  },
  "reassignEntities": {
    "cancel": "रद्द गर्नुहोस्",
    "makeReassignments": "पुनः तोक्नुहोस्",
    "previous": "अघिल्लो",
    "next": "अर्को",
    "removeUser": "प्रयोगकर्ता हटाउनुहोस्",
    "confirm": "पुष्टि गर्नुहोस्",
    "save": "सुरक्षित गर्नुहोस्",
    "allSelected": "सबै {{count}} चयन गरिए:",
    "reviewInfo": "तलको जानकारी समीक्षा गर्नुहोस्",
    "addUserToGroup": "प्रयोगकर्तालाई समूहमा थप्नुहोस्",
    "warningMessage": "यदि तपाईं हटाउने कार्य जारी राख्नुहुन्छ भने, निजी ट्याग भएका कागजातहरूमा पहुँचका लागि आवश्यक निम्न समूहहरूमा निम्न प्रयोगकर्ताहरू थपिनेछन्:",
    "userAddedToGroups": "{{userName}} लाई निम्न समूहहरूमा थपिनेछ:",
    "steps": {
      "owner": "कागजातहरू",
      "changeRequestOwner": "परिवर्तन अनुरोधहरू",
      "approver": "स्वीकृति कार्यहरू",
      "reviewer": "समीक्षा कार्यहरू",
      "issues": "समस्याहरू",
      "events": "घटनाहरू",
      "tasks": "कार्यहरू",
      "summary": "परिवर्तनहरू पुष्टि गरी प्रयोगकर्ता हटाउनुहोस्",
      "summaryRefactor": "प्रयोगकर्ता हटाउने कार्य पुष्टि गर्नुहोस्",
      "default_owner": "पूर्वनिर्धारित घटना तोकिएको व्यक्ति",
      "eventTemplateOwner": "घटना टेम्प्लेटहरू",
      "control": "नियन्त्रणहरू",
      "documentTemplateOwner": "कागजात टेम्प्लेटहरू"
    },
    "columns": {
      "id": "ID",
      "title": "शीर्षक",
      "newOwner": "नयाँ जिम्मेवार व्यक्ति",
      "status": "स्थिति",
      "tags": "ट्यागहरू",
      "name": "नाम",
      "prefix": "उपसर्ग"
    },
    "summary": {
      "documents": "कागजातहरू:",
      "documentTemplates": "कागजात टेम्प्लेटहरू:",
      "changeRequests": "परिवर्तन अनुरोधहरू:",
      "controls": "नियन्त्रणहरू:",
      "eventTemplates": "घटना टेम्प्लेटहरू:",
      "approvalActions": "स्वीकृति कार्यहरू:",
      "reviewActions": "समीक्षा कार्यहरू:",
      "issueActions": "समस्या कार्यहरू:",
      "eventActions": "घटना कार्यहरू:",
      "issueCollaboratorNote": "यदि नयाँ जिम्मेवार व्यक्ति पहिले नै कुनै घटनाको सहकर्मी हुनुहुन्छ भने, उहाँलाई त्यसका सहकर्मीहरूबाट हटाइनेछ।",
      "taskActions": "कार्य गतिविधिहरू:",
      "ownershipTransfer": "{{count}} {{type}} को स्वामित्व {{name}} लाई हस्तान्तरण गरिनेछ",
      "ownershipTransferPlural": "{{count}} वटा {{type}} को स्वामित्व {{name}} लाई हस्तान्तरण गरिनेछ",
      "actionTransfer": "{{count}} {{type}} कार्य {{name}} लाई हस्तान्तरण गरिनेछ",
      "actionTransferPlural": "{{count}} वटा {{type}} कार्यहरू {{name}} लाई हस्तान्तरण गरिनेछन्",
      "eventTemplateTransfer": "{{count}} घटना टेम्प्लेटको {{ownershipType}} {{name}} लाई हस्तान्तरण गरिनेछ",
      "eventTemplateTransferPlural": "{{count}} वटा घटना टेम्प्लेटहरूको {{ownershipType}} {{name}} लाई हस्तान्तरण गरिनेछ"
    }
  },
  "groups": {
    "subtitle": "आफ्नो टोलीलाई व्यवस्थित गर्न र पहुँच नियन्त्रण गर्न प्रयोगकर्ता समूहहरू सिर्जना र व्यवस्थापन गर्नुहोस्",
    "createNewGroup": "नयाँ समूह सिर्जना गर्नुहोस्",
    "assignManagers": "प्रबन्धकहरू तोक्नुहोस्",
    "editGroup": "समूह सम्पादन गर्नुहोस्",
    "deleteGroup": "समूह मेटाउनुहोस्",
    "confirmDeleteTitle": "समूह मेटाउने पुष्टि गर्नुहोस्",
    "confirmDeleteMessage": "के तपाईं \"{{groupName}}\" समूह मेटाउन निश्चित हुनुहुन्छ? Qualio तालिम योजनाको हिस्सा रहेको समूह मेटाउँदा तपाईंका तालिम असाइनमेन्टहरूमा असर पर्न सक्छ। प्रभावित योजनाहरू पहिचान गर्न कृपया तालिम म्याट्रिक्स जाँच गर्नुहोस्।",
    "yesDeleteGroup": "हो, समूह मेटाउनुहोस्",
    "searchPlaceholder": "समूह वा प्रबन्धकहरू खोज्नुहोस्...",
    "table": {
      "groupName": "समूहको नाम",
      "groupManagers": "समूह प्रबन्धकहरू",
      "includeInReports": "तालिम प्रतिवेदनहरूमा समावेश गर्नुहोस्"
    },
    "noManagers": "--"
  },
  "groupForm": {
    "groupName": "समूहको नाम",
    "includeInReports": "प्रतिवेदनहरूमा समावेश गर्नुहोस्",
    "minLengthError": "कम्तीमा 1 वर्ण आवश्यक छ।",
    "duplicateError": "\"{{groupName}}\" नाम भएको समूह पहिले नै अवस्थित छ।"
  },
  "roles": {
    "basic": "आधारभूत",
    "normal": "सामान्य",
    "quality": "गुणस्तर"
  },
  "features": {
    "qualityEvents": {
      "name": "गुणस्तर घटनाहरू",
      "description": "\"गुणस्तर घटना\" भनेको नियामक आवश्यकताहरूअनुसार पूर्वनिर्धारित कार्य वा प्रतिक्रिया र ट्र्याकिङ आवश्यक पर्ने घटना हो। गुणस्तर प्रयोगकर्ताहरूले घटना सिर्जना गर्न, स्वामित्व तोक्न र सम्बन्धित चरण/कार्यहरूमा स्वीकृति दिन सक्छन्।",
      "enable": "गुणस्तर घटनाहरू सक्षम गर्नुहोस्",
      "permissions": {
        "manageWorkflow": "कार्यप्रवाह व्यवस्थापन गर्नुहोस्",
        "manageAttributes": "विशेषताहरू व्यवस्थापन गर्नुहोस्",
        "workOnIssue": "समस्यामा काम गर्नुहोस्",
        "createIssue": "समस्या सिर्जना गर्नुहोस्",
        "view": "घटनाहरू हेर्नुहोस्",
        "create": "घटना सिर्जना गर्नुहोस्",
        "workOnExisting": "अवस्थित घटनामा काम गर्नुहोस्",
        "manageTemplates": "घटना टेम्प्लेटहरू सिर्जना र व्यवस्थापन गर्नुहोस्"
      }
    },
    "migrations": {
      "name": "माइग्रेसनहरू",
      "description": "माइग्रेसन प्रबन्धकले तपाईंलाई अनबोर्डिङका क्रममा Qualio मा कागजातहरू सजिलै अपलोड गर्न दिन्छ।",
      "enable": "माइग्रेसनहरू सक्षम गर्नुहोस्",
      "permissions": {
        "create": "सिर्जना गर्नुहोस्",
        "view": "हेर्नुहोस्",
        "prepare": "तयार गर्नुहोस्",
        "approve": "स्वीकृत गर्नुहोस्",
        "uploadFiles": "फाइलहरू अपलोड गर्नुहोस्"
      }
    },
    "suppliers": {
      "name": "आपूर्तिकर्ताहरू",
      "description": "आपूर्तिकर्ता सुविधाले तपाईंको टोलीलाई आपूर्तिकर्ता नीति कन्फिगर गर्न, स्वीकृत आपूर्तिकर्ता सूची व्यवस्थापन गर्न र आपूर्तिकर्ता अडिट कागजातहरू भण्डारण गर्न सक्षम बनाउँछ।",
      "access": "आपूर्तिकर्ताहरूमा पहुँच"
    },
    "designControls": {
      "name": "डिजाइन नियन्त्रणहरू",
      "description": "डिजाइन नियन्त्रण सुविधाले तपाईंको उत्पादनको डिजाइन र विकास प्रक्रियाको कुशल व्यवस्थापन र दस्तावेजीकरण सम्भव बनाउँछ, जसले अनुपालन र गुणस्तर सुनिश्चित गर्छ।",
      "access": "डिजाइन नियन्त्रणहरूमा पहुँच"
    },
    "compliance": {
      "name": "अनुपालन",
      "description": "अनुपालन सुविधाले तपाईंको टोलीलाई फ्रेमवर्कहरू व्यवस्थापन गर्न, आवश्यकताको स्थिति ट्र्याक गर्न र गुणस्तर तथा नियामक मापदण्डहरूको पालना प्रदर्शन गर्न सक्षम बनाउँछ।",
      "access": "अनुपालनमा पहुँच"
    },
    "apiCapabilities": {
      "name": "API क्षमताहरू",
      "description": "API क्षमताहरूले तपाईंका उद्यम प्रणालीहरूलाई Qualio कागजात र तालिमसँग सहज एकीकरण र स्वचालनका लागि प्रोग्रामयोग्य इन्टरफेसहरूमा पहुँच दिन्छ।",
      "access": "API क्षमताहरूमा पहुँच",
      "deprecatedNote": "यसले पुरानो API मा मात्र पहुँच दिन्छ। नयाँ API मा पहुँच दिन कृपया \"विकासकर्ता API टोकनहरू\" प्रयोग गर्नुहोस्।"
    },
    "events": {
      "name": "घटनाहरू",
      "description": "घटना सुविधाले तपाईंको टोलीलाई मूल कारणदेखि प्रभावकारिता प्रमाणीकरणसम्म सबै गुणस्तर घटनाहरू सिर्जना र व्यवस्थापन गर्न सक्षम बनाउँछ।"
    },
    "notAvailable": "यो सुविधा तपाईंको हालको इजाजतपत्रमा उपलब्ध छैन। अपग्रेड गरी गुणस्तर घटनाहरू सक्षम गर्न कृपया आफ्नो ग्राहक सफलता प्रतिनिधिलाई सम्पर्क गर्नुहोस्।",
    "disableConfirmation": "सुविधाहरू पुनः सक्रिय गरिँदा अवस्थित डेटा सुरक्षित रहनेछ र उपलब्ध गराइनेछ। तर, परिमार्जन गरिएका सबै प्रयोगकर्ता अनुमतिहरू मेटाइनेछन् र सुविधा पुनः सक्रिय गर्दा पूर्वनिर्धारित पहुँचमा रिसेट हुनेछन्। के तपाईं निष्क्रिय पार्न निश्चित हुनुहुन्छ?",
    "disableTitle": "{{name}} निष्क्रिय पार्नुहोस्",
    "yesDisable": "हो, {{name}} निष्क्रिय पार्नुहोस्",
    "enable": "सुविधा सक्षम गर्नुहोस्",
    "disable": "{{name}} निष्क्रिय पार्नुहोस्",
    "role": "भूमिका",
    "access": "पहुँच",
    "none": "कुनै पनि छैन",
    "upgradeMessage": "यो सुविधा तपाईंको हालको इजाजतपत्रमा उपलब्ध छैन। अपग्रेड गरी गुणस्तर घटनाहरू सक्षम गर्न कृपया आफ्नो ग्राहक सफलता प्रतिनिधिलाई सम्पर्क गर्नुहोस्।"
  },
  "status": {
    "draft": "मस्यौदा",
    "forReview": "समीक्षाका लागि",
    "forApproval": "स्वीकृतिका लागि",
    "approved": "स्वीकृत",
    "approvalDeclined": "स्वीकृति अस्वीकार गरियो",
    "effective": "प्रभावकारी"
  },
  "forms": {
    "fullName": "पूरा नाम",
    "email": "इमेल ठेगाना",
    "role": "प्रयोगकर्ताको भूमिका",
    "adminAccess": "प्रशासक पहुँच",
    "billingAccess": "बिलिङ पहुँच",
    "learnMoreRoles": "प्रयोगकर्ता भूमिकाहरूबारे थप जान्नुहोस्।",
    "labels": {
      "fullName": "पूरा नाम",
      "emailAddress": "इमेल ठेगाना",
      "userRole": "प्रयोगकर्ताको भूमिका",
      "jobTitle": "पद",
      "department": "विभाग",
      "location": "स्थान",
      "adminAccess": "प्रशासक पहुँच",
      "billingAccess": "बिलिङ पहुँच",
      "name": "नाम",
      "role": "भूमिका",
      "groups": "समूहहरू"
    },
    "placeholders": {
      "whatIsThisTokenFor": "यो टोकन केका लागि हो?",
      "filterByNameEmailGroup": "नाम, इमेल वा समूहको नामअनुसार फिल्टर गर्नुहोस्..."
    },
    "helperText": {
      "adminAccess": "प्रशासक पहुँच दिँदा प्रयोगकर्ताहरूले प्रयोगकर्ता र समूहहरू थप्न/हटाउन तथा अनुमतिहरू सम्पादन गर्न सक्नेछन्",
      "adminAccessExtended": "प्रशासक पहुँच दिँदा प्रयोगकर्ताहरूले प्रयोगकर्ताहरू थप्न/हटाउन, समूहहरू थप्न/हटाउन र घटना तथा आपूर्तिकर्ताहरूका अनुमतिहरू व्यवस्थापन गर्न सक्नेछन्",
      "inviteUser": "दिइएको इमेल ठेगानामा निमन्त्रणा सन्देश पठाइनेछ। यसमा एउटा पुष्टि लिङ्क हुनेछ, जसमार्फत इमेल ठेगानाका धनी तपाईंको संस्थामा सामेल हुन सक्नेछन्।",
      "learnMoreRoles": "प्रयोगकर्ता भूमिकाहरूबारे थप जान्नुहोस्।",
      "learnMorePermissions": "अनुमतिहरूबारे थप जान्नुहोस्।"
    },
    "permissions": {
      "viewEvents": "घटनाहरू हेर्नुहोस्",
      "createEvents": "घटना सिर्जना गर्नुहोस्",
      "editEvents": "अवस्थित घटनामा काम गर्नुहोस्",
      "manageEvents": "घटना टेम्प्लेटहरू सिर्जना र व्यवस्थापन गर्नुहोस्",
      "accessSuppliers": "आपूर्तिकर्ताहरूमा पहुँच",
      "accessDesignControls": "डिजाइन नियन्त्रणहरूमा पहुँच",
      "accessCompliance": "अनुपालनमा पहुँच"
    }
  },
  "apiCapabilities": {
    "header": "API क्षमताहरू",
    "description": "API क्षमताहरूले तपाईंका उद्यम प्रणालीहरूलाई Qualio कागजात र तालिमसँग सहज एकीकरण र स्वचालनका लागि प्रोग्रामयोग्य इन्टरफेसहरूमा पहुँच दिन्छ।",
    "deprecatedDescription": "यसले पुरानो API मा मात्र पहुँच दिन्छ। नयाँ API मा पहुँच दिन कृपया \"विकासकर्ता API टोकनहरू\" प्रयोग गर्नुहोस्।",
    "errorFetchKeys": "सर्भर त्रुटिका कारण कम्पनीसँग API कुञ्जीहरू छन् कि छैनन् भन्ने निर्धारण गर्न सकिएन।",
    "access": "API क्षमताहरूमा पहुँच"
  },
  "modals": {
    "updatePermissions": {
      "title": "व्यक्तिगत अनुमतिहरू अद्यावधिक गर्ने?",
      "message": "तपाईं यो प्रयोगकर्ताको भूमिका परिवर्तन गर्दै हुनुहुन्छ। उनीहरूलाई भूमिकाका अतिरिक्त विशेष व्यक्तिगत अनुमतिहरू पनि तोकिएका छन्। के तपाईं उनीहरूका व्यक्तिगत अनुमतिहरू पनि अद्यावधिक गर्न चाहनुहुन्छ?",
      "yesUpdate": "हो, अनुमतिहरू अद्यावधिक गर्नुहोस्",
      "noKeep": "होइन, हालका अनुमतिहरू राख्नुहोस्"
    },
    "inviteUser": {
      "title": "प्रयोगकर्तालाई निमन्त्रणा पठाउनुहोस्",
      "sendInvitation": "निमन्त्रणा पठाउनुहोस्",
      "resendInvitation": "निमन्त्रणा पुनः पठाउनुहोस्",
      "reinviteMessage": "{{email}} पहिले यस खाताको सक्रिय सदस्य थिए। उनीहरूलाई पुनः निमन्त्रणा पठाउँदा पहिले पूरा गरिएका गतिविधिहरूसहित उनीहरूको प्रोफाइल पुनर्स्थापित हुनेछ।"
    },
    "setRole": {
      "title": "चयन गरिएका प्रयोगकर्ताहरूको भूमिका तोक्नुहोस्"
    },
    "addToGroup": {
      "title": "चयन गरिएका प्रयोगकर्ताहरूलाई समूहमा थप्नुहोस्",
      "adding": "थपिँदैछ..."
    },
    "manageGroups": {
      "title": "चयन गरिएका प्रयोगकर्ताहरूका समूहहरू व्यवस्थापन गर्नुहोस्",
      "save": "सुरक्षित गर्नुहोस्",
      "saving": "सुरक्षित गरिँदैछ...",
      "searchPlaceholder": "समूहको नामअनुसार फिल्टर गर्नुहोस्..."
    },
    "removeFromGroup": {
      "title": "चयन गरिएका प्रयोगकर्ताहरूलाई समूहबाट हटाउनुहोस्",
      "removing": "हटाइँदैछ...",
      "visibilityWarning": "चयन गरिएका प्रयोगकर्ताहरूलाई यो समूहबाट हटाउँदा केही कागजातहरू वा टेम्प्लेटहरू तिनका जिम्मेवार व्यक्तिहरूबाट लुकाइनेछन्। के तपाईं जारी राख्न निश्चित हुनुहुन्छ?",
      "confirmTitle": "यो कार्यले सामग्रीको दृश्यतामा असर गर्छ"
    },
    "removeUser": {
      "title": "प्रयोगकर्ता हटाउनुहोस्",
      "confirmMessage": "के तपाईं प्रयोगकर्ता \"{{name}}\" लाई हटाउन निश्चित हुनुहुन्छ?",
      "yesRemoveUser": "हो, प्रयोगकर्ता हटाउनुहोस्"
    },
    "cancelInvite": {
      "title": "निमन्त्रणा रद्द गर्नुहोस्",
      "confirmMessage": "के तपाईं यो प्रयोगकर्ताको निमन्त्रणा रद्द गर्न निश्चित हुनुहुन्छ?",
      "yesCancelUser": "हो, प्रयोगकर्ता रद्द गर्नुहोस्"
    },
    "assignManagers": {
      "title": "प्रबन्धकहरू तोक्नुहोस्",
      "searchPlaceholder": "नाम, इमेल वा समूहको नामअनुसार फिल्टर गर्नुहोस्...",
      "assigning": "तोकिँदैछ...",
      "save": "सुरक्षित गर्नुहोस्"
    },
    "editUser": {
      "title": "प्रयोगकर्ता सम्पादन गर्नुहोस्"
    },
    "editGroup": {
      "title": "समूह सम्पादन गर्नुहोस्"
    }
  },
  "editUser": {
    "title": "प्रयोगकर्ता सम्पादन गर्नुहोस्",
    "header": "प्रयोगकर्ता सम्पादन गर्नुहोस्",
    "general": "सामान्य जानकारी",
    "permissions": "अनुमतिहरू",
    "defaultPermissions": "पूर्वनिर्धारित अनुमतिहरू",
    "events": "घटनाहरू",
    "suppliers": "आपूर्तिकर्ताहरू",
    "designControls": "डिजाइन नियन्त्रणहरू",
    "compliance": "अनुपालन",
    "eventsDescription": "घटना सुविधाले तपाईंको टोलीलाई मूल कारणदेखि प्रभावकारिता प्रमाणीकरणसम्म सबै गुणस्तर घटनाहरू सिर्जना र व्यवस्थापन गर्न सक्षम बनाउँछ",
    "suppliersDescription": "आपूर्तिकर्ता सुविधाले तपाईंको टोलीलाई आपूर्तिकर्ता नीति कन्फिगर गर्न, स्वीकृत आपूर्तिकर्ता सूची व्यवस्थापन गर्न र आपूर्तिकर्ता अडिट कागजातहरू भण्डारण गर्न सक्षम बनाउँछ",
    "designControlsDescription": "डिजाइन नियन्त्रण सुविधाले तपाईंको उत्पादनको डिजाइन र विकास प्रक्रियाको कुशल व्यवस्थापन र दस्तावेजीकरण सम्भव बनाउँछ, जसले अनुपालन र गुणस्तर सुनिश्चित गर्छ।",
    "complianceDescription": "अनुपालन सुविधाले तपाईंको टोलीलाई फ्रेमवर्कहरू व्यवस्थापन गर्न, आवश्यकताको स्थिति ट्र्याक गर्न र गुणस्तर तथा नियामक मापदण्डहरूको पालना प्रदर्शन गर्न सक्षम बनाउँछ।",
    "eventsWarning": "थप अनुमतिहरू सक्षम गर्न \"घटनाहरू हेर्नुहोस्\" चयन गरिएको हुनुपर्छ",
    "viewEventsWarning": "थप अनुमतिहरू सक्षम गर्न \"घटनाहरू हेर्नुहोस्\" चयन गरिएको हुनुपर्छ",
    "resetPermissions": "पूर्वनिर्धारित अनुमतिहरूमा रिसेट गर्नुहोस्",
    "resetToDefault": "पूर्वनिर्धारित अनुमतिहरूमा रिसेट गर्नुहोस्",
    "saveChanges": "परिवर्तनहरू सुरक्षित गर्नुहोस्",
    "eventsPermissions": "घटना अनुमतिहरू",
    "defaultPermissionsTable": {
      "role": "भूमिका",
      "defaultPermissions": "पूर्वनिर्धारित अनुमतिहरू"
    },
    "validation": {
      "invalidFullName": "अमान्य पूरा नाम",
      "invalidEmail": "अमान्य इमेल"
    }
  },
  "messages": {
    "success": {
      "saved": "सफलतापूर्वक सुरक्षित गरियो",
      "deleted": "सफलतापूर्वक मेटाइयो",
      "submitted": "समीक्षाका लागि पेश गरियो",
      "invitationSent": "निमन्त्रणा पठाइयो!",
      "invitationResent": "निमन्त्रणा पुनः पठाइयो!",
      "invitationCanceled": "प्रयोगकर्ताको निमन्त्रणा सफलतापूर्वक रद्द गरियो।",
      "userRemoved": "प्रयोगकर्ता सफलतापूर्वक हटाइयो।",
      "userDeleted": "प्रयोगकर्ता सफलतापूर्वक मेटाइयो!",
      "userUpdated": "प्रयोगकर्ता सफलतापूर्वक अद्यावधिक गरियो!",
      "groupCreated": "समूह सफलतापूर्वक सिर्जना गरियो!",
      "groupDeleted": "समूह सफलतापूर्वक मेटाइयो!",
      "groupUpdated": "समूह सफलतापूर्वक अद्यावधिक गरियो!",
      "roleChanged": "{{count}} प्रयोगकर्ता(हरू) को भूमिका सफलतापूर्वक परिवर्तन गरियो!",
      "usersAdded": "{{count}} प्रयोगकर्ता(हरू) लाई चयन गरिएको समूहमा सफलतापूर्वक थपियो",
      "usersRemoved": "{{count}} प्रयोगकर्ता(हरू) लाई चयन गरिएको समूहबाट सफलतापूर्वक हटाइयो",
      "groupsUpdated": "समूह सदस्यता सफलतापूर्वक अद्यावधिक गरियो!",
      "managersAssigned": "प्रबन्धकहरू सफलतापूर्वक तोकिए",
      "permissionsUpdated": "इन्स्ट्यान्स अनुमतिहरू सफलतापूर्वक अद्यावधिक गरिए",
      "tokenCreated": "नयाँ टोकन सिर्जना गरियो",
      "tokenDeleted": "विकासकर्ता API टोकन सफलतापूर्वक मेटाइयो",
      "tokenUpdated": "विकासकर्ता API टोकन सफलतापूर्वक अद्यावधिक गरियो"
    },
    "error": {
      "generic": "त्रुटि भयो। कृपया फेरि प्रयास गर्नुहोस्।",
      "notFound": "वस्तु फेला परेन",
      "unauthorized": "तपाईंलाई यो कार्य गर्ने अधिकार छैन",
      "sendInvitation": "केही गडबड भयो! निमन्त्रणा पठाउन सकिएन।",
      "resendInvitation": "केही गडबड भयो! निमन्त्रणा पुनः पठाउन सकिएन।",
      "cancelInvitation": "केही गडबड भयो! प्रयोगकर्ताको निमन्त्रणा रद्द गर्न सकिएन।",
      "removeUser": "केही गडबड भयो! प्रयोगकर्ता हटाउन सकिएन।",
      "updateUser": "केही गडबड भयो! प्रयोगकर्ता अद्यावधिक गर्न सकिएन।",
      "extractOwnedItems": "केही गडबड भयो! यो प्रयोगकर्ताको स्वामित्वमा रहेका वस्तुहरू निकाल्न सकिएन।",
      "createGroup": "केही गडबड भयो! समूह सिर्जना गर्न सकिएन।",
      "deleteGroup": "केही गडबड भयो! समूह मेटाउन सकिएन।",
      "updateGroup": "केही गडबड भयो! समूह अद्यावधिक गर्न सकिएन।",
      "updateRole": "केही गडबड भयो! भूमिका अद्यावधिक गर्न सकिएन।",
      "setUsersToGroup": "चयन गरिएको समूहमा प्रयोगकर्ताहरू राख्न सकिएन",
      "addUsersToGroup": "चयन गरिएको समूहमा प्रयोगकर्ताहरू राख्न सकिएन",
      "removeUsersFromGroup": "चयन गरिएको समूहबाट प्रयोगकर्ता(हरू) हटाउन सकिएन",
      "manageGroups": "समूह सदस्यता अद्यावधिक गर्न सकिएन। कृपया फेरि प्रयास गर्नुहोस्।",
      "assignManagers": "प्रबन्धकहरू तोक्न असफल भयो",
      "updateMfa": "यो कम्पनीको MFA स्थिति अद्यावधिक गर्न सकिएन",
      "updatePermissions": "इन्स्ट्यान्स अनुमतिहरू अद्यावधिक गर्न असफल भयो",
      "loadSettings": "सेटिङहरू लोड गर्न असफल भयो।",
      "fetchFeatures": "सुविधाहरू प्राप्त गर्न असफल भयो",
      "updateFeatures": "सुविधाहरू अद्यावधिक गर्न असफल भयो",
      "createToken": "सर्भर त्रुटिका कारण अनुरोध गरिएको API KEY सिर्जना गर्न सकिएन",
      "tokenNameExists": "यो नाम भएको API कुञ्जी पहिले नै अवस्थित छ। कृपया फरक नाम छान्नुहोस्।",
      "deleteToken": "सर्भर त्रुटिका कारण अनुरोध गरिएको API KEY मेटाउन सकिएन",
      "rotateToken": "सर्भर त्रुटिका कारण अनुरोध गरिएको API KEY रोटेट गर्न सकिएन",
      "showApiKeys": "सर्भर त्रुटिका कारण API कुञ्जीहरू देखाउन सकिएन",
      "reassignEntities": "वस्तुहरू पुनः तोक्न असफल भयो। कृपया फेरि प्रयास गर्नुहोस्।",
      "updateToken": "सर्भर त्रुटिका कारण अनुरोध गरिएको API टोकन अद्यावधिक गर्न सकिएन"
    },
    "validation": {
      "required": "यो फिल्ड आवश्यक छ",
      "invalidEmail": "अमान्य इमेल ठेगाना।",
      "minLength": "कम्तीमा {{min}} वर्ण हुनुपर्छ",
      "maxLength": "{{max}} वर्णभन्दा बढी हुनु हुँदैन",
      "invalidTokenName": "अमान्य टोकन नाम",
      "minimumAdmins": "यो कार्यले कम्पनीमा प्रशासकहरूको संख्या शून्य बनाउनेछ। प्रत्येक कम्पनीमा कम्तीमा 1 प्रशासक आवश्यक छ।",
      "minimumQuality": "कम्पनीमा कम्तीमा एक गुणस्तर प्रयोगकर्ता आवश्यक छ।",
      "documentsHidden": "यो कार्यले एक वा बढी कागजातहरू तिनका जिम्मेवार व्यक्तिहरूबाट लुकाउनेछ।",
      "templatesHidden": "यो कार्यले एक वा बढी टेम्प्लेटहरू तिनका जिम्मेवार व्यक्तिहरूबाट लुकाउनेछ।",
      "userAlreadyExists": "इमेल {{email}} बाट दर्ता भएका प्रयोगकर्ता पहिले नै यो कम्पनीका सदस्य हुनुहुन्छ।",
      "totalUsersLimit": "कुल प्रयोगकर्ताहरूको सीमा पुगेको छ।",
      "activeUsersLimit": "सक्रिय प्रयोगकर्ताहरूको सीमा पुगेको छ।",
      "userExistsInQualio": "यो इमेल ठेगाना भएका प्रयोगकर्ता Qualio मा पहिले नै अवस्थित छन्।"
    }
  },
  "emptyStates": {
    "noResults": "कुनै नतिजा फेला परेन",
    "noData": "देखाउन कुनै डेटा छैन।",
    "noBetaFeatures": {
      "title": "कुनै सक्रिय बीटा सुविधा उपलब्ध छैन",
      "subtitle": "कृपया भविष्यमा फेरि जाँच गर्नुहोस्। हामी Qualio अनुभवमा सुधार गर्न निरन्तर काम गरिरहेका छौं।"
    },
    "noApiTokens": {
      "title": "कुनै API टोकन सिर्जना गरिएको छैन",
      "subtitle": "स्क्रिप्ट वा परीक्षणका लागि API टोकन चाहिन्छ? Qualio API मा छिटो पहुँचका लागि API टोकन उत्पन्न गर्नुहोस्।",
      "viewPortal": "विकासकर्ता पोर्टल हेर्नुहोस्",
      "createToken": "टोकन सिर्जना गर्नुहोस्"
    },
    "noApiAccess": {
      "title": "तपाईंसँग विकासकर्ता API मा पहुँच छैन",
      "subtitle": "Qualio मा विकासकर्ता API पहुँच प्राप्त गर्न हाम्रो सहायता टोलीलाई सम्पर्क गर्नुहोस्।",
      "contactSupport": "Qualio सहायतालाई सम्पर्क गर्नुहोस्"
    }
  },
  "security": {
    "description": "तपाईंको संस्थाका सबै प्रयोगकर्ताहरूका लागि प्रमाणीकरण आवश्यकताहरू र सुरक्षा सेटिङहरू व्यवस्थापन गर्नुहोस्।",
    "mfa": {
      "label": "बहु-कारक प्रमाणीकरण",
      "description": "समग्र सुरक्षा बढाउन, साइन इन गर्दा तपाईंको संस्थाका सबै प्रयोगकर्ताहरूलाई पासवर्डका साथै प्रमाणीकरण कोड पनि प्रदान गर्न अनिवार्य गर्नुहोस्।",
      "enable": "बहु-कारक प्रमाणीकरण सक्षम गर्नुहोस्",
      "disableTitle": "बहु-कारक प्रमाणीकरण निष्क्रिय पार्नुहोस्",
      "disableMessage": "के तपाईं यो सेटिङ निष्क्रिय पार्न निश्चित हुनुहुन्छ? निष्क्रिय पारेपछि प्रयोगकर्ताहरूले बहु-कारक प्रमाणीकरण प्रयोग गरेर साइन इन गर्नुपर्ने छैन।"
    }
  },
  "permissions": {
    "instancePermissions": "इन्स्ट्यान्स अनुमतिहरू",
    "aiEditing": {
      "label": "एआई-सञ्चालित सम्पादन",
      "description": "एआईद्वारा सञ्चालित सुझाव गरिएका तालिम मूल्याङ्कनहरू, परिवर्तन नियन्त्रणहरू र कागजात सुधारहरू।",
      "enable": "एआई-सञ्चालित सम्पादन सक्षम गर्नुहोस्"
    },
    "mcp": {
      "label": "MCP पहुँच",
      "description": "एआई सहायक र एजेन्टहरूलाई Qualio को MCP सर्भरमार्फत यो इन्स्ट्यान्समा जडान हुन अनुमति दिनुहोस्।",
      "enable": "MCP पहुँच सक्षम गर्नुहोस्"
    },
    "copilot": {
      "label": "Qualio Copilot",
      "description": "यो इन्स्ट्यान्सका लागि Qualio Copilot एआई सहायक सक्षम गर्नुहोस्।",
      "enable": "Copilot सक्षम गर्नुहोस्"
    },
    "reviewers": {
      "label": "समीक्षकहरू",
      "description": "आधारभूत प्रयोगकर्ताहरूलाई कागजातहरूमा समीक्षकका रूपमा थपिने अनुमति दिनुहोस्।",
      "enable": "सबै आधारभूत प्रयोगकर्ताहरू समीक्षक बन्न सक्छन्"
    },
    "supportAccess": {
      "label": "Qualio सहायता पहुँच",
      "description": "Qualio सहायतालाई पढ्ने-मात्र मोडमा तपाईंको इन्स्ट्यान्समा पहुँच गर्न अनुमति दिनुहोस्।",
      "enable": "सहायता पहुँच सक्षम गर्नुहोस्"
    },
    "saveChanges": "परिवर्तनहरू सुरक्षित गर्नुहोस्",
    "termsOfService": {
      "prefix": "निम्न चिन्ह लगाइएका अनुमतिहरूले",
      "tos": "एआई-सञ्चालित सुविधाहरू सक्षम गर्छन्। तिनलाई सक्षम गरेर, तपाईं Qualio का सेवाका सर्तहरूको पालना गर्न सहमत हुनुहुन्छ।",
      "fairUsage": "सबै प्रयोगकर्ताहरूलाई एकनास अनुभव सुनिश्चित गर्न, उच्च मागका समयमा हामी प्रयोग सीमाहरू लागू गर्न सक्छौं।"
    }
  },
  "betaFeatures": {
    "description": "नवीनतम सुविधाहरूलाई आफ्नो इन्स्ट्यान्समा सक्षम गरेर अन्वेषण र परीक्षण गर्नुहोस्। तपाईंको प्रतिक्रियाले हामीलाई यी नवप्रवर्तनहरू परिष्कृत र पूर्ण बनाउन मद्दत गर्छ, त्यसैले तपाईंलाई के लाग्छ हामीलाई बताउनुहोस्। बीटा सुविधा सक्षम गर्दा परिवर्तन लागू हुन केही मिनेट लाग्न सक्छ। यदि तपाईंले परिवर्तनहरू देख्नुभएन भने, आफ्नो ब्राउजर रिफ्रेस गरी हेर्नुहोस्। यी सुविधाहरूबारे थप जान्न हाम्रो",
    "helpCenter": "सहायता केन्द्र हेर्नुहोस्।",
    "packageNotice": "सामान्य उपलब्धतापछि बीटा सुविधाहरूमा पहुँच प्याकेजमा निर्भर हुन सक्छ। थप जान्न आफ्नो CSM लाई सम्पर्क गर्नुहोस्।",
    "enabled": "{{name}} सक्षम गरियो",
    "disabled": "{{name}} निष्क्रिय पारियो",
    "enable": "{{name}} सक्षम गर्नुहोस्",
    "termsOfService": {
      "prefix": "निम्नमध्ये कुनै पनि बीटा सुविधा सक्षम गर्न टगल क्लिक गरेर, तपाईं Qualio का",
      "terms": "सेवाका सर्तहरू",
      "middle": "को पालना गर्न सहमत हुनुहुन्छ, जसअनुसार तपाईंले सक्षम गर्नुभएका बीटा सुविधाहरू निम्नका प्रयोजनका लागि \"बीटा सुविधाहरू\" को अंश हुनेछन्:",
      "suffix": "सेवाका सर्तहरू।"
    }
  },
  "devApi": {
    "backToTokens": "API टोकनहरूमा फर्कनुहोस्",
    "createToken": "टोकन सिर्जना गर्नुहोस्",
    "tokenRoleHelper": "तपाईं यो टोकनलाई कुन भूमिकाका विशेषाधिकारहरू दिन चाहनुहुन्छ?",
    "adminAccessHelper": "यो टोकनलाई प्रयोगकर्ताहरू थप्ने/हटाउने, समूहहरू थप्ने/हटाउने र घटना तथा आपूर्तिकर्ताहरूका अनुमतिहरू व्यवस्थापन गर्ने क्षमता दिनुहोस्।",
    "tokenGroupsHelper": "वैकल्पिक रूपमा, यो टोकनलाई प्रयोगकर्ताजस्तै निजी कागजात, घटना आदि हेर्न दिन समूहहरूमा थप्नुहोस्।",
    "editToken": "टोकन सम्पादन गर्नुहोस्"
  },
  "developerApi": {
    "description": "API टोकनहरू Qualio API मा प्रमाणीकृत पहुँच दिने सुरक्षित र अद्वितीय कुञ्जीहरू हुन्। यिनले बाह्य प्रणालीहरूसँग सहज एकीकरण गरी कार्यप्रवाह स्वचालित गर्न, डेटा सिंक गर्न र अनुपालन ट्र्याकिङ सुदृढ गर्न सक्षम बनाउँछन्।",
    "manageDescription": "यहाँ तपाईं आफ्ना API टोकनहरू व्यवस्थापन गर्न सक्नुहुन्छ। तपाईं तिनलाई सिर्जना गर्न, मेटाउन र रोटेट गर्न सक्नुहुन्छ। टोकन रोटेट गर्दा नयाँ टोकन कुञ्जी उत्पन्न हुन्छ र पुरानो अमान्य हुन्छ। नाम र अनुमतिहरू परिवर्तन हुँदैनन्।",
    "expirationNote": "रोटेट नगरिएमा प्रत्येक टोकनको म्याद एक वर्षपछि सकिन्छ। कुञ्जी प्रयोग गरेर गरिएका सबै कार्यहरू तपाईंले टोकनका लागि छान्नुभएको नामसहित अडिट ट्रेलमा लग गरिन्छन्।",
    "docsAlert": "Qualio API सँग एकीकरण गर्दै हुनुहुन्छ? हाम्रो विकासकर्ता पोर्टलमा गाइडहरू र पूर्ण API सन्दर्भ पाउनुहोस्।",
    "viewApiDocs": "API कागजात हेर्नुहोस्",
    "createToken": "टोकन सिर्जना गर्नुहोस्",
    "backToTokens": "API टोकनहरूमा फर्कनुहोस्",
    "createTokenHeader": "टोकन सिर्जना गर्नुहोस्",
    "tokenName": "नाम",
    "tokenRole": "भूमिका",
    "tokenRoleHelper": "तपाईं यो टोकनलाई कुन भूमिकाका विशेषाधिकारहरू दिन चाहनुहुन्छ?",
    "tokenGroups": "समूहहरू",
    "tokenGroupsHelper": "वैकल्पिक रूपमा, यो टोकनलाई प्रयोगकर्ताजस्तै निजी कागजात, घटना आदि हेर्न दिन समूहहरूमा थप्नुहोस्।",
    "adminAccessHelper": "यो टोकनलाई प्रयोगकर्ताहरू थप्ने/हटाउने, समूहहरू थप्ने/हटाउने र घटना तथा आपूर्तिकर्ताहरूका अनुमतिहरू व्यवस्थापन गर्ने क्षमता दिनुहोस्।",
    "tokenCreatedTitle": "नयाँ टोकन सिर्जना गरियो",
    "storeSecurelyTitle": "यो टोकन सुरक्षित रूपमा राख्नुहोस्",
    "storeSecurelyMessage": "पूरा टोकन हेर्न सक्ने यो नै एकमात्र अवसर हो।",
    "apiTokenLabel": "API टोकन",
    "copyToken": "टोकन प्रतिलिपि गर्नुहोस्",
    "tokenLostWarning": "टोकन हराएमा, तपाईंले नयाँ टोकन उत्पन्न गर्नुपर्नेछ। नयाँ टोकन पुनः उत्पन्न गर्दा पुरानो टोकन अमान्य हुनेछ, तर यसका अनुमतिहरू र नाम उस्तै रहनेछन्।",
    "deleteToken": "विकासकर्ता API टोकन मेटाउनुहोस्",
    "confirmDeleteTitle": "टोकन मेटाउने पुष्टि गर्नुहोस्",
    "confirmDeleteMessage": "के तपाईं \"{{tokenName}}\" टोकन मेटाउन निश्चित हुनुहुन्छ? यो टोकन प्रयोग गर्ने सबै एकीकरणहरूले तुरुन्तै Qualio API मा पहुँच गुमाउनेछन्।",
    "confirmRotateTitle": "टोकन रोटेट गर्ने पुष्टि गर्नुहोस्",
    "confirmRotateMessage": "के तपाईं \"{{tokenName}}\" टोकन रोटेट गर्न निश्चित हुनुहुन्छ? यसले नयाँ टोकन कुञ्जी उत्पन्न गर्छ र हालको कुञ्जीलाई तुरुन्तै अमान्य बनाउँछ, त्यसैले यसलाई प्रयोग गर्ने सबै एकीकरणहरूले अद्यावधिक नगरिएसम्म पहुँच गुमाउनेछन्।",
    "table": {
      "name": "नाम",
      "created": "सिर्जना गरिएको",
      "expires": "म्याद सकिने",
      "type": "प्रकार",
      "personal": "व्यक्तिगत",
      "system": "प्रणाली",
      "personalTooltip": "यो टोकन वास्तविक प्रयोगकर्तासँग जोडिएको छ र उनीहरूको पहुँच प्राप्त गर्छ। त्यो प्रयोगकर्ता निष्क्रिय पारिएमा यसले काम गर्न छोड्नेछ।",
      "systemTooltip": "यो टोकन कुनै वास्तविक प्रयोगकर्तासँग जोडिएको छैन र यसका आफ्नै अनुमतिहरू छन्।",
      "rotate": "रोटेट गर्नुहोस्",
      "delete": "मेटाउनुहोस्"
    }
  },
  "reassign": {
    "removeUserTitle": "प्रयोगकर्ता हटाउनुहोस्: {{name}}",
    "removeUserTitleGeneric": "प्रयोगकर्ता हटाउनुहोस्",
    "description": "प्रयोगकर्ता हटाउनुअघि तपाईंले कागजातहरू र बाँकी समस्या, कार्य तथा गतिविधिहरूको स्वामित्व अन्य प्रयोगकर्ताहरूलाई हस्तान्तरण गर्नुपर्छ।",
    "descriptionEvents": "प्रयोगकर्ता हटाउनुअघि तपाईंले कागजातहरू र बाँकी घटना, कार्य तथा गतिविधिहरूको स्वामित्व अन्य प्रयोगकर्ताहरूलाई हस्तान्तरण गर्नुपर्छ।",
    "descriptionExtended": "प्रयोगकर्ता हटाउनुअघि तपाईंले कागजात, टेम्प्लेट, बाँकी समस्या, कार्य तथा गतिविधिहरूको स्वामित्व अन्य प्रयोगकर्ताहरूलाई हस्तान्तरण गर्नुपर्छ।",
    "descriptionExtendedEvents": "प्रयोगकर्ता हटाउनुअघि तपाईंले कागजात, टेम्प्लेट, बाँकी घटना, कार्य तथा गतिविधिहरूको स्वामित्व अन्य प्रयोगकर्ताहरूलाई हस्तान्तरण गर्नुपर्छ।",
    "steps": {
      "documents": "कागजातहरू",
      "changeRequests": "परिवर्तन अनुरोधहरू",
      "approvalActions": "स्वीकृति कार्यहरू",
      "reviewActions": "समीक्षा कार्यहरू",
      "issues": "समस्याहरू",
      "tasks": "कार्यहरू",
      "confirmChanges": "परिवर्तनहरू पुष्टि गरी प्रयोगकर्ता हटाउनुहोस्",
      "defaultEventAssignee": "पूर्वनिर्धारित घटना तोकिएको व्यक्ति",
      "eventTemplates": "घटना टेम्प्लेटहरू",
      "controls": "नियन्त्रणहरू",
      "documentTemplates": "कागजात टेम्प्लेटहरू"
    },
    "bulkSelect": {
      "allSelected": "सबै {{size}} चयन गरिए:",
      "save": "सुरक्षित गर्नुहोस्"
    },
    "table": {
      "id": "ID",
      "title": "शीर्षक",
      "newOwner": "नयाँ जिम्मेवार व्यक्ति",
      "status": "स्थिति",
      "tags": "ट्यागहरू",
      "name": "नाम",
      "prefix": "उपसर्ग"
    },
    "summary": {
      "reviewInfo": "तलको जानकारी समीक्षा गर्नुहोस्",
      "addUserToGroupTitle": "प्रयोगकर्तालाई समूहमा थप्नुहोस्",
      "addUserToGroupMessage": "यदि तपाईं हटाउने कार्य जारी राख्नुहुन्छ भने, निजी ट्याग भएका कागजातहरूमा पहुँचका लागि आवश्यक निम्न समूहहरूमा निम्न प्रयोगकर्ताहरू थपिनेछन्:",
      "userAddedToGroups": "{{userName}} लाई निम्न समूहहरूमा थपिनेछ: {{groupNames}}"
    }
  },
  "aria": {
    "userlistCheckbox": "userlist_checkbox",
    "addToGroup": "समूहमा थप्नुहोस्",
    "removeFromGroup": "समूहबाट हटाउनुहोस्",
    "manageGroups": "समूहहरू व्यवस्थापन गर्नुहोस्",
    "adminAccess": "प्रशासक पहुँच",
    "billingAccess": "बिलिङ पहुँच",
    "email": "इमेल",
    "fullName": "fullName",
    "role": "भूमिका",
    "group": "समूह",
    "groupName": "समूहको नाम",
    "includeInReports": "प्रतिवेदनहरूमा समावेश गर्नुहोस्",
    "inviteUserForm": "inviteUserForm",
    "groupForm": "समूह फारम",
    "nextButton": "next_button",
    "canViewQualityEvents": "गुणस्तर घटनाहरू हेर्न सक्छ",
    "canCreateQualityEvents": "गुणस्तर घटनाहरू सिर्जना गर्न सक्छ",
    "canEditQualityEvents": "गुणस्तर घटनाहरू सम्पादन गर्न सक्छ",
    "canManageQualityEvents": "गुणस्तर घटनाहरू व्यवस्थापन गर्न सक्छ"
  }
}
